import { Heading, Link } from '@dittolive/anvil'
import React from 'react'

import type { App, AppsTableConfig } from '../../types'

type Props<T extends App> = {
  app: T
  url: string
  config: AppsTableConfig
  renderExtra?: React.ReactNode
}

export default function AppRow<T extends App>({
  app,
  url,
  config,
  renderExtra,
}: Props<T>) {
  const { idText } = config.terminology

  return (
    <Link to={url} data-testid="appTableRow">
      <div className="hover:bg-background-surface-hovered flex h-36 flex-col justify-between p-4">
        <Heading level={3}>{app.name}</Heading>

        <div className="flex flex-col gap-y-2">
          <Heading level={4}>{idText}</Heading>
          <p className="font-plex-mono text-foreground-subtle text-sm">
            {app.id}
          </p>
          {renderExtra}
        </div>
      </div>
    </Link>
  )
}
